import { Controller } from "@hotwired/stimulus"
import { noticeMessage } from '../common/notifications'
import toastr from "toastr"

// Connects to data-controller="notice"
export default class extends Controller {
  static targets = ["heading", "type", "text", 'notice']
  connect() {
  }

  noticeTargetConnected(ele) {
    this.showNotice()
  }
  showNotice() {
    noticeMessage(this.typeTarget.innerHTML, this.textTarget.innerHTML, this.headingTarget.innerHTML)
    // toastr[this.typeTarget.innerHTML](this.textTarget.innerHTML, this.headingTarget.innerHTML, this.options())
  }

  options() {
    return {
      closeButton: true,
      debug: false,
      newestOnTop: true,
      progressBar: true,
      positionClass: "toast-top-right",
      preventDuplicates: false,
      onclick: null,
      showDuration: "300",
      hideDuration: "1000",
      timeOut: "5000",
      extendedTimeOut: "1000",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "slideDown",
      hideMethod: "fadeOut",
    };    
  }
}
